import { getCurrentEnv } from '../hooks/apiUrlResolver';

const currentEnv = getCurrentEnv();
const getDomainSuffix = () => (window.location.host.toLowerCase().includes('.net') ? '.net' : '.com');

const getEssentialsSubdomain = () => {
  if (currentEnv === 'prd') return 'essentials';
  if (currentEnv === 'qap') return 'qap-essentials';
  if (currentEnv === 'qua') return 'qa-essentials';
  return 'test-essentials';
};

const getDeveloperHubLocalBaseUrl = () => 'http://localhost:8000';

const getEssentialsUrl = () =>
  `https://${getEssentialsSubdomain()}.availity${getDomainSuffix()}`;

export const getDeveloperHubApiUrl = (endpoint: string) =>
  currentEnv === 'local'
    ? `${getDeveloperHubLocalBaseUrl()}/api/${endpoint}`
    : `${getEssentialsUrl()}/cloud/web/appl/developer-hub/api/${endpoint}`;

export const getDeveloperHubPublicApiUrl = (endpoint: string) =>
  currentEnv === 'local'
    ? `${getDeveloperHubLocalBaseUrl()}/api/${endpoint}`
    : `${getEssentialsUrl()}/cloud/public/appl/developer-hub/api/${endpoint}`;

export default getEssentialsUrl;
